import { render, staticRenderFns } from "./UrlShortener.vue?vue&type=template&id=52cb9dee&scoped=true"
import script from "./UrlShortener.vue?vue&type=script&lang=ts"
export * from "./UrlShortener.vue?vue&type=script&lang=ts"
import style0 from "./UrlShortener.vue?vue&type=style&index=0&id=52cb9dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb9dee",
  null
  
)

export default component.exports